export const LS_TRATHUONG_LIST_INITING             = 'LS_TRATHUONG_LIST_INITING'
export const LS_TRATHUONG_LIST_REQUESTING          = 'LS_TRATHUONG_LIST_REQUESTING'
export const LS_TRATHUONG_LIST_SUCCESS             = 'LS_TRATHUONG_LIST_SUCCESS'
export const LS_TRATHUONG_LIST_ERROR               = 'LS_TRATHUONG_LIST_ERROR'   

export const LS_TRATHUONG_EXPORT_XLS_REQUESTING     = 'LS_TRATHUONG_EXPORT_XLS_REQUESTING'
export const LS_TRATHUONG_EXPORT_XLS_SUCCESS        = 'LS_TRATHUONG_EXPORT_XLS_SUCCESS'
export const LS_TRATHUONG_EXPORT_XLS_ERROR          = 'LS_TRATHUONG_EXPORT_XLS_ERROR'

export const LS_TRATHUONG_REMOVE_REQUESTING        = 'LS_TRATHUONG_REMOVE_REQUESTING'
export const LS_TRATHUONG_REMOVE_SUCCESS           = 'LS_TRATHUONG_REMOVE_SUCCESS'
export const LS_TRATHUONG_REMOVE_ERROR             = 'LS_TRATHUONG_REMOVE_ERROR' 

export const LS_TRATHUONG_LIST_API                 = '/api/v1/khachhang/lichsutrathuong_list_by_store'   
export const LS_TRATHUONG_REMOVE_API               = '/api/v1/khachhang/lichsutrathuong_remove_by_id' 
export const LS_TRATHUONG_EXPORT_API               = '/api/v1/khachhang/lichsutrathuong_export_list_by_store'    


// WEBPACK FOOTER //
// ./src/views/LichSuTraThuong/constants.js